export default __webpack_public_path__ + "static/media/settings.09d8d12d.svg";